import { throttle } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { setBodyColor } from 'utils/client/bodyBg'

import './SSpyContainer.scss'

let ScrollMagic

/**
 * Base component which you can extend to use logic of ScrollSpy.
 *
 * !! Do not forget to extend state of component instead of create new one
 * if you want ot use state:
 *
 * `this.state.someNewAttribute = 'something'`
 *
 * @return {Component} Component — SSpyContainer
 */
export default class SSpyContainer extends Component {
  static propTypes = {
    /** Object with localized texts */
    texts: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)

    this.controller = null
    this.scenes = []
    this.swiperRef = React.createRef()
    this.throttledUpdateAllScenes = throttle(this.updateAllScenes, 100)

    this.state = {
      texts: null,
      sectionsRefs: null,
      sceneActiveIndex: 0,
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { texts } = nextProps

    if (texts && texts !== prevState.texts) {
      return {
        texts,
        sectionsRefs: texts.list.map(() => React.createRef()),
      }
    }

    return null
  }

  componentDidMount() {
    const { texts } = this.props

    ScrollMagic = require('ScrollMagic')
    this.controller = new ScrollMagic.Controller({
      globalSceneOptions: { triggerHook: 0.35 },
    })

    if (texts) {
      this.createNewScenes()
      this.controller.addScene(this.scenes)
    }

    setBodyColor({ isLight: false })
    window.addEventListener('resize', this.throttledUpdateAllScenes)
  }

  componentDidUpdate(prevProps) {
    const { texts } = this.props

    if (
      texts &&
      texts !== prevProps.texts &&
      !this.controller &&
      !this.scenes.length
    ) {
      this.createNewScenes()
      this.controller.addScene(this.scenes)
    } else if (this.controller && this.scenes.length) {
      this.updateAllScenes()
    }
  }

  componentWillUnmount() {
    setBodyColor({ isLight: true })
    this.scenes = []
    this.controller.destroy()
    window.removeEventListener('resize', this.throttledUpdateAllScenes)
  }

  createNewScenes = () => {
    const { sectionsRefs } = this.state

    this.scenes = sectionsRefs.map((item, key) =>
      new ScrollMagic.Scene({
        triggerElement: item.current,
        duration: item.current.getBoundingClientRect().height,
      }).on('enter', () => this.setState({ sceneActiveIndex: key })),
    )
  }

  /**
   * @param {sectionIndex} sectionIndex - index of the active scroll magic scene
   * @return {void} void
   */
  handleUpdateActiveScene = sectionIndex => {
    if (this.state.sectionsRefs[sectionIndex]) {
      const updatedDuration = this.state.sectionsRefs[
        sectionIndex
      ].current.getBoundingClientRect().height

      this.scenes[sectionIndex].duration(updatedDuration)
      this.scenes[sectionIndex].refresh()
    }
  }

  updateAllScenes = () => {
    this.scenes.forEach((item, key) => {
      const updatedDuration = this.state.sectionsRefs[
        key
      ].current.getBoundingClientRect().height

      item.duration(updatedDuration)

      return item.refresh()
    })
  }

  render() {
    return null
  }
}
